"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _messages = require("./messages");
/* eslint-disable no-console */

const ANONYMOUS = '<<anonymous>>';
const domElement = () => {
  // Element is not defined unless the Browser API is defined
  if (typeof Element === 'undefined') {
    return _propTypes.default.any;
  }
  return _propTypes.default.instanceOf(Element);
};
const elementOrArrayOfElements = () => _propTypes.default.oneOfType([_propTypes.default.arrayOf(domElement()), domElement()]);
function newAssign(target, ...sources) {
  const newTarget = target;
  for (const source of sources) {
    Object.keys(source).forEach(key => {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        newTarget[key] = source[key];
      }
    });
  }
  return newTarget;
}
const wrapValidator = (validator, typeName, typeChecker = null) => newAssign(validator.bind(), {
  typeName,
  typeChecker,
  isRequired: newAssign(validator.isRequired.bind(), {
    typeName,
    typeChecker,
    typeRequired: true
  })
});
const createChainableTypeChecker = validate => {
  const checkType = (isRequired, props, propName, componentName, location, propFullName) => {
    const safeComponentName = componentName || ANONYMOUS;
    const safePropFullName = propFullName || propName;
    const value = props[propName];
    if (typeof value === 'undefined' || value === null) {
      if (isRequired) {
        return new TypeError(`The ${location} \`${safePropFullName}\` is marked as required in \`${safeComponentName}\`, but its value is \`${value === null ? 'null' : typeof value}\`.`);
      }
      return null;
    }
    return validate(props, propName, safeComponentName, location, safePropFullName);
  };
  const chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
};
const range = (min, max) => {
  if (Number.isNaN(min)) {
    console.error('The `min` parameter supplied to the `range` propType is required and must be a `number`.');
    return () => null;
  }
  if (Number.isNaN(max)) {
    console.error('The `max` parameter supplied to the `range` propType is required and must be a `number`.');
    return () => null;
  }
  if (min >= max) {
    console.error('In the `range` propType, the `min` value must be less than the `max` value.');
    return () => null;
  }
  const validate = (props, propName, componentName, location, propFullName) => {
    // eslint-disable-next-line react/destructuring-assignment
    const value = props[propName];
    // If no value is provided, don't fail validation.
    if (typeof value === 'undefined' || value === null) {
      return null;
    }
    if (Number.isNaN(value)) {
      return new TypeError(`Invalid ${location} \`${propFullName}\` of type \`${typeof value}\` supplied to \`${componentName}\`, expected \`number\`.`);
    }
    if (value < min || value > max) {
      return new Error(`The ${location} \`${propFullName}\` supplied to \`${componentName}\` has a value of \`${value}\`, which is not in the range \`${min}\` to \`${max}\` (inclusive).`);
    }
    return null;
  };
  return wrapValidator(createChainableTypeChecker(validate), 'range', {
    min,
    max
  });
};
const localizedString = id => {
  const validate = (props, propName, componentName, location, propFullName) => {
    // eslint-disable-next-line react/destructuring-assignment
    const value = props[propName];
    if (!value) {
      return new Error(`The ${location} \`${propFullName}\` was not supplied to \`${componentName}\`. ${(0, _messages.LOCALIZED_TEXT_MESSAGE)(id)}`);
    }
    if (typeof value !== 'string') {
      return new Error(`The ${location} \`${propFullName}\` must be a string. ${(0, _messages.LOCALIZED_TEXT_MESSAGE)(id)}`);
    }
    return null;
  };
  return wrapValidator(createChainableTypeChecker(validate), 'localizedString', id);
};
const localizedStringOrFunction = id => {
  const validate = (props, propName, componentName, location, propFullName) => {
    // eslint-disable-next-line react/destructuring-assignment
    const value = props[propName];
    if (!value) {
      return new Error(`The ${location} \`${propFullName}\` was not supplied to \`${componentName}\`. ${(0, _messages.LOCALIZED_TEXT_MESSAGE)(id)}`);
    }
    if (typeof value !== 'string' && typeof value !== 'function') {
      return new Error(`The ${location} \`${propFullName}\` must be a string or a function. ${(0, _messages.LOCALIZED_TEXT_MESSAGE)(id)}`);
    }
    return null;
  };
  return wrapValidator(createChainableTypeChecker(validate), 'localizedStringOrFunction', id);
};
const i18n = obj => {
  if (!obj) {
    console.error('The shape parameter supplied to the `i18n` propType is required.');
    return () => null;
  }
  const validate = (props, propName, componentName, location, propFullName) => {
    // eslint-disable-next-line react/destructuring-assignment
    const value = props[propName];
    if (!value) {
      return new Error(`The ${location} \`${propFullName}\` was not supplied to \`${componentName}\`.`);
    }
    const shapeKeys = Object.keys(obj);
    const valueKeys = Object.keys(value);
    const shapeKeysMismatch = shapeKeys.filter(key => !valueKeys.some(k => key === k));
    const valueKeysMismatch = valueKeys.filter(key => !shapeKeys.some(k => key === k));
    const shapeKeysString = shapeKeysMismatch.map(key => `\`${key}\``).join(', ');
    const valueKeysString = valueKeysMismatch.map(key => `\`${key}\``).join(', ');
    const introString = `The ${location} \`${propFullName}\` supplied to \`${componentName}\``;
    if (valueKeys.length < shapeKeys.length && !valueKeysString) {
      return new Error(`${introString} has ${valueKeys.length} strings when it expected ${shapeKeys.length}. Missing ${shapeKeysString}.`);
    }
    if (valueKeys.length > shapeKeys.length && !shapeKeysString) {
      return new Error(`${introString} has extra keys: ${valueKeysString}.`);
    }
    if (shapeKeysMismatch.length) {
      return new Error(`${introString} is missing: ${shapeKeysString}.  It has extra keys: ${valueKeysString}.`);
    }
    if (valueKeysMismatch.length) {
      return new Error(`${introString} has extra keys: ${valueKeysString}.  It expects: ${shapeKeysString}.`);
    }
    return null;
  };
  return wrapValidator(createChainableTypeChecker(validate), 'i18n', obj);
};
const arrayOfTupleTypes = propType => (props, propName, componentName) => {
  // eslint-disable-next-line react/destructuring-assignment
  if (!Array.isArray(props[propName])) {
    return new Error(`Invalid property ${propName} supplied to ${componentName} needs to be an array.`);
  }
  // eslint-disable-next-line consistent-return, react/destructuring-assignment
  Array.from(props[propName]).forEach(innerProp => {
    if (!Array.isArray(innerProp) || innerProp.length !== 2) {
      return new Error(`Invalid property ${propName} supplied to ${componentName} needs to be an array of arrays with length 2.`);
    }
    _propTypes.default.checkPropTypes({
      [`${propName}[0]`]: propType
    }, {
      [`${propName}[0]`]: innerProp[0]
    }, `${propName}[0]`, componentName);
    _propTypes.default.checkPropTypes({
      [`${propName}[1]`]: propType
    }, {
      [`${propName}[1]`]: innerProp[1]
    }, `${propName}[1]`, componentName);
  });
  return null;
};
const conditionallyRequired = (propType, condition, conditionMessage) => (props, propName, componentName) => {
  // eslint-disable-next-line react/destructuring-assignment
  if (condition(props) && !props[propName]) {
    return new Error(`The prop \`${propName}\` is required in \`${componentName}\` when ${conditionMessage}.`);
  }
  // eslint-disable-next-line react/destructuring-assignment
  _propTypes.default.checkPropTypes({
    [`${propName}`]: propType
  }, {
    [`${propName}`]: props[propName]
  }, propName, componentName);
  return null;
};
const notDefined = () => null;
var _default = exports.default = {
  arrayOfTupleTypes,
  conditionallyRequired,
  domElement,
  elementOrArrayOfElements,
  i18n,
  range,
  localizedString,
  localizedStringOrFunction,
  notDefined
};